module.exports = __webpack_public_path__ + "img/side_zipper_length.0d15b459.png";